export default __webpack_public_path__ + "static/media/Stage-1024x827.110cf74e.jpg";